module.exports = __webpack_public_path__ + "img/icn_design@3x.da4853d0.png";